import { useEffect } from 'react';

const Goftino = () => {
  useEffect(() => {
    const scriptId = 'kJHRAh'; // Replace with your actual ID
    const scriptUrl = `https://www.goftino.com/widget/${scriptId}`;
    const savedScriptUrl = localStorage.getItem(`goftino_${scriptId}`);
    const finalUrl = savedScriptUrl ? `${scriptUrl}?o=${savedScriptUrl}` : scriptUrl;

    // Create and append the script element
    const script = document.createElement('script');
    script.src = finalUrl;
    script.async = true;
    script.onload = () => {
      console.log('Goftino chat widget loaded successfully');
    };
    script.onerror = () => {
      console.error('Failed to load Goftino chat widget');
    };

    document.body.appendChild(script);

    // Cleanup script on component unmount
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null; // This component does not render anything itself
};

export default Goftino;
